import { useEffect, useState } from "react";

export function useWindowActive() {
	const [isWindowActive, setIsWindowActive] = useState(true);
	useEffect(() => {
		const handleVisibilityChange = () => {
			setIsWindowActive(document.visibilityState === "visible");
		};

		const intervalId = setInterval(() => {
			if (document.hasFocus()) {
				setIsWindowActive(true);
			}
		}, 500);

		document.addEventListener("visibilitychange", handleVisibilityChange);
		return () => {
			document.removeEventListener("visibilitychange", handleVisibilityChange);
			clearInterval(intervalId);
		};
	}, []);
	return isWindowActive;
}
